<div dotCmsPageContext>
  <custom-dot-cms-layout>
    <!-- Todo: Development for header and footer -->
    @if (false) { } @else {
    <custom-dot-cms-layout-grid />
    }
  </custom-dot-cms-layout>
</div>
